import { useAtomValue } from "jotai";
import { loadable } from "jotai/utils";
import { useMemo, useRef } from "react";

import {
	$agentInstructionFiles,
	type AgentInstructionFileInfo,
} from "../../internal/document/agents-md.atom";

export const useAgentInstructionFiles = (
	documentId: string | undefined
): AgentInstructionFileInfo[] => {
	const docId = documentId ?? "";

	const filesAtom = useMemo(() => $agentInstructionFiles({ documentId: docId }), [docId]);
	const filesLoadable = useAtomValue(loadable(filesAtom));
	const lastData = useRef<AgentInstructionFileInfo[]>([]);

	if (!documentId) {
		lastData.current = [];
		return [];
	}

	if (filesLoadable.state === "hasData") {
		lastData.current = filesLoadable.data;
		return filesLoadable.data;
	}

	return lastData.current;
};
